module.exports = __webpack_public_path__ + "static/media/ActionButtonsScreen.95c39053.png";